import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import AppImage from '../../../components/AppImage';
import { useLanguage } from '../../../contexts/LanguageContext';

const StepPhotoUpload = ({ data, onNext, onBack }) => {
  const { t } = useLanguage();
  const [photos, setPhotos] = useState(data?.photos || []);
  const [uploading, setUploading] = useState(false);

  const handleFileSelect = (e) => {
    const files = Array.from(e?.target?.files || []);
    const newPhotos = files?.map((file, index) => ({
      id: `photo-${Date.now()}-${index}`,
      file,
      preview: URL.createObjectURL(file),
      enhanced: false
    }));
    setPhotos([...photos, ...newPhotos]);
  };

  const removePhoto = (photoId) => {
    setPhotos(photos?.filter(p => p?.id !== photoId));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    onNext({ photos });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-foreground mb-2">{t('uploadPhotosTitle')}</h2>
        <p className="text-muted-foreground">{t('uploadPhotosDesc')}</p>
      </div>

      <div className="space-y-4">
        <div className="border-2 border-dashed border-border rounded-lg p-8 text-center hover:border-primary transition-colors">
          <input
            type="file"
            id="photo-upload"
            multiple
            accept="image/*"
            onChange={handleFileSelect}
            className="hidden"
          />
          <label htmlFor="photo-upload" className="cursor-pointer">
            <Icon name="Upload" size={48} color="var(--color-primary)" className="mx-auto mb-4" />
            <p className="text-lg font-semibold text-foreground mb-2">{t('clickToUpload')}</p>
            <p className="text-sm text-muted-foreground">{t('dragAndDrop')}</p>
            <p className="text-xs text-muted-foreground mt-2">{t('pngJpgLimit')}</p>
          </label>
        </div>

        {photos?.length > 0 && (
          <div>
            <div className="flex items-center justify-between mb-3">
              <p className="text-sm font-medium text-foreground">
                {photos?.length} {t('photosUploaded')}
              </p>
              <div className="flex items-center gap-2 text-sm text-primary">
                <Icon name="Sparkles" size={16} color="currentColor" />
                <span>{t('aiEnhancementAvailable')}</span>
              </div>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {photos?.map((photo) => (
                <div key={photo?.id} className="relative group">
                  <div className="aspect-square rounded-lg overflow-hidden border border-border">
                    <AppImage
                      src={photo?.preview}
                      alt="Property photo"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <button
                    type="button"
                    onClick={() => removePhoto(photo?.id)}
                    className="absolute top-2 right-2 w-8 h-8 rounded-full bg-error text-error-foreground flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                  >
                    <Icon name="X" size={16} color="currentColor" />
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="flex justify-between">
        <Button type="button" variant="outline" onClick={onBack} iconName="ArrowLeft">{t('back')}</Button>
        <Button type="submit" variant="default" iconName="ArrowRight" iconPosition="right" disabled={photos?.length === 0}>
          {t('continue')}
        </Button>
      </div>
    </form>
  );
};

export default StepPhotoUpload;